// extracted by mini-css-extract-plugin
export default {"notVisitedRecently":"index_notVisitedRecently__RgBIt"};